import { helpers } from '../helpers.js';

var calendar = {
	options: {
		currentDate: null,
		today: null,
		monthNames: MONTH_NAMES,
	},

	selectors: {
		monthYear: 'monthYear',
		daysContainer: 'daysContainer',
	},

	init: function () {
		const self = this;

		self.options.currentDate = new Date();
		self.options.today = new Date();

		self.initCalendar();
	},

	// Initialize calendar
	initCalendar: function() {
		const self = this;

		self.renderCalendar();
		
		document.getElementById('prevMonth').addEventListener('click', () => {
			self.options.currentDate.setMonth(self.options.currentDate.getMonth() - 1);
			self.renderCalendar();
		});

		document.getElementById('nextMonth').addEventListener('click', () => {
			self.options.currentDate.setMonth(self.options.currentDate.getMonth() + 1);
			self.renderCalendar();
		});
	},

	// Check if a date is booked
	isDateBooked: function(date) {
		const self = this;
		const dateStr = self.formatDate(date);
		
		return BOOKINGS.some(booking => {
			const from = new Date(booking.date_from);
			const to = new Date(booking.date_to);
			const current = new Date(dateStr);
			
			// Reset time to compare only dates
			from.setHours(0, 0, 0, 0);
			to.setHours(0, 0, 0, 0);
			current.setHours(0, 0, 0, 0);
			
			return current >= from && current <= to;
		});
	},

	// Format date as YYYY-MM-DD
	formatDate: function(date) {
		const self = this;
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');

		return `${year}-${month}-${day}`;
	},

	// Check if two dates are the same day
	isSameDay: function(date1, date2) {
		const self = this;

		return date1.getFullYear() === date2.getFullYear() &&
				date1.getMonth() === date2.getMonth() &&
				date1.getDate() === date2.getDate();
	},

	// Render calendar
	renderCalendar: function() {
		const self = this;

		const year = self.options.currentDate.getFullYear();
		const month = self.options.currentDate.getMonth();

		console.log( self.options.monthNames );

		// Update month/year display
		document.getElementById( self.selectors.monthYear ).textContent = `${self.options.monthNames[month]} ${year}`;

		// Get first day of month and number of days
		const firstDay = new Date(year, month, 1);
		const lastDay = new Date(year, month + 1, 0);
		const numDays = lastDay.getDate();
		
		// Get day of week for first day (0 = Sunday, 1 = Monday, etc.)
		// Convert to Monday = 0 format
		let startDay = firstDay.getDay() - 1;
		if (startDay === -1) startDay = 6;

		// Clear days container
		const daysContainer = document.getElementById( self.selectors.daysContainer );
		daysContainer.innerHTML = '';

		// Add empty cells for days before month starts
		for (let i = 0; i < startDay; i++) {
			const emptyDay = document.createElement('div');
			emptyDay.className = 'day empty';
			daysContainer.appendChild(emptyDay);
		}

		// Add days of month
		for (let day = 1; day <= numDays; day++) {
			const dayElement = document.createElement('div');
			const currentDayDate = new Date(year, month, day);
			
			dayElement.className = 'day';
			dayElement.textContent = day;

			// Check if date is booked
			if (self.isDateBooked(currentDayDate)) {
				dayElement.classList.add('booked');
			} else {
				dayElement.classList.add('available');
			}

			// Mark today
			if (self.isSameDay(currentDayDate, self.options.today)) {
				dayElement.classList.add('today');
			}

			daysContainer.appendChild(dayElement);
		}
	}
}

// Export
export { calendar };